import type { EnemyConfig } from '../../entities/EnemyConfig';

export const BOARLING_CONFIG: EnemyConfig = {
  id: 'boarling',
  displayName: 'Кабанчик',
  maxHp: 1,
  speed: 90,
  movementBehavior: 'drifting_chase',
  movementParams: {
    wobbleAmplitude: 30,
    wobbleFrequency: 0.8,
  },
  size: 27,
  color: 0x9b6b3f,
  scoreReward: 6,
};
